const ClosedEye = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 3.75C14.6152 3.75 17.0588 5.25522 19.0566 7.10156C20.7913 8.7047 22.1077 10.489 22.8047 11.5225L23.0645 11.916C23.0912 11.9575 23.0983 12.0001 23.085 12.042L23.0645 12.084C22.4745 12.9984 21.0386 15.0667 19.0566 16.8984C17.0588 18.7448 14.6152 20.25 12 20.25C9.38482 20.25 6.9412 18.7448 4.94336 16.8984C3.20868 15.2953 1.89232 13.511 1.19531 12.4775L0.935547 12.084C0.90877 12.0425 0.901659 11.9999 0.915039 11.958L0.935547 11.916C1.52555 11.0016 2.96135 8.93327 4.94336 7.10156C6.9412 5.25522 9.38482 3.75 12 3.75Z"
        stroke="#1A1919"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="12" r="4.25" stroke="#1A1919" strokeWidth="1.5" />
      <path
        d="M19.3955 2.14258C20.0829 1.58192 21.0966 1.62198 21.7373 2.2627L21.8574 2.39551C22.3807 3.03706 22.3807 3.96294 21.8574 4.60449L21.7373 4.7373L4.2373 22.2373C3.59658 22.878 2.58286 22.9181 1.89551 22.3574L1.7627 22.2373C1.07928 21.5539 1.07928 20.4461 1.7627 19.7627L19.2627 2.2627L19.3955 2.14258Z"
        fill="#1A1919"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ClosedEye;
